import moment from 'moment-timezone';

export const isPagoInDateRange = (pagoFecha, fechas) => {
    const fechaPago = moment(pagoFecha);
    return fechaPago.isBetween(fechas.desde, fechas.hasta, "days", "[]");
};

const getSafAfterDateRangeIndex = (saf, fechas) => {

    return saf.findIndex(({ fecha }) => {
        const fechaPago = moment(fecha);
        return fechaPago.isAfter(fechas.hasta, 'days');
    });
};

const detalladoFilters = {
    vivsIds: ({ id_vivienda }, values) => values.indexOf(id_vivienda) !== -1,
    prodsIds: ({ id_producto }, values) => values.indexOf(id_producto) !== -1,
    foliosIds: ({ id_docCobro }, values) => {
        const folioIndex = values.indexOf(id_docCobro);
        folioIndex !== -1 && values.splice(folioIndex, 1);
        return folioIndex !== -1;
    },
    pagoEstado: ({ pago, saldo, id_docCobro }, value) => value !== 3 ? value !== 2 ? value !== 1 ?
        true
        : (saldo === 0 || pago > 0)
        : saldo > 0
        : id_docCobro === null
    ,
    pagosFechas: ({ pagos }, pagosRange) =>  pagos.some(({ fecha }) => isPagoInDateRange(fecha, pagosRange))
};

const concentradoFilters = {
    vivsIds: ({ id_vivienda }, values) => values.indexOf(id_vivienda) !== -1,
    vacios: ({ productos }, value) =>
        productos.some(({ pago }) => pago > 0),
    // pagosFechas: ({ productos }, dateRange) => 
    //     productos.some(({ pagos }) => 
    //         pagos.some(({ fecha }) => isPagoInDateRange(fecha, dateRange)))
};

export const getPagoActual = (documento, fechas) => {

    const getPagosFiltradosSum = (pagos, fechas) => pagos.reduce((acum, { fecha, pago }) => {
            
        const pagoIsBetweenFilter = isPagoInDateRange(fecha, fechas);
        return pagoIsBetweenFilter ? acum + pago : acum;

    }, 0);

    const getSafAfterDateRange = (saf, fechas) => {

        const dateIsAfterIndex = getSafAfterDateRangeIndex(saf, fechas);
    
        return dateIsAfterIndex === -1 ? saf[saf.length - 1].saldo
            : dateIsAfterIndex === 0 ? 0
                : saf[dateIsAfterIndex - 1].saldo
    };

    const { pago, pagos, saf } = documento;

    return pagos.length > 0 ? fechas ? getPagosFiltradosSum(pagos, fechas) : pago
            : saf && saf.length > 0 ? fechas ? getSafAfterDateRange(saf, fechas) : saf[saf.length - 1].saldo
            : 0;
};

export const applyDetalladoFilters = ({ informes, filters }) => {

    const setDocFiltersToApply = () => Object.entries(filters).reduce((active, [key, value]) => {

        const filter = detalladoFilters[key];

        if(key === 'pagosFechas' && filters?.['pagoEstado'] === 2) return active;

        if (filter !== undefined) {

            const values = key === 'foliosIds' ? [...value] :
                key === 'pagosFechas' ? { desde: moment(value.desde), hasta: moment(value.hasta) }
                    : value;

            active.push({ filter, values });
        }

        return active;

    }, []);

    const safFiltersToApply = (() => {

        const { vivsIds } = filters;

        if(vivsIds) return [{ filter: detalladoFilters['vivsIds'], values: vivsIds }];

        return [];
    })();

    if(filters.pagoEstado && filters.pagoEstado === 3) {

        return informes.filter((informe) => 
            informe.id_docCobro === null 
                && safFiltersToApply.every(({ filter, values }) => filter(informe, values))
        );

    } else {

        const docFiltersToApply = setDocFiltersToApply();

        let lastViviendaId = -1;
    
        return informes.filter((informe) => {
    
            if(informe.id_docCobro !== null) {
    
                const passedFilter = docFiltersToApply.every(({ filter, values }) => filter(informe, values));
    
                if(passedFilter) lastViviendaId = informe.id_vivienda;
    
                return passedFilter;
    
            }
            else {
    
                const viviendaIdCopy = lastViviendaId;
    
                const passedFilter = safFiltersToApply.every(({ filter, values }) => filter(informe, values));
                if(passedFilter) lastViviendaId = -1;
    
                return passedFilter && !(viviendaIdCopy === -1 || viviendaIdCopy !== informe.id_vivienda);
            }
        });
    }
};

export const applyConcentradoFilters = ({ informes, filters }) => {

    const filtersToApply = [];

    const { vivsIds, vacios, pagosFechas } = filters;

    if (vivsIds) {
        filtersToApply.push({ filter: concentradoFilters.vivsIds, values: vivsIds })
    }

    if (vacios === 0) {
        filtersToApply.push({ filter: concentradoFilters.vacios, values: vacios })
    }

    // if (pagosFechas) {

    //     const { desde, hasta } = pagosFechas;

    //     /* Also check only for enabled headers? */

    //     filtersToApply.push({ 
    //         filter: concentradoFilters.pagosFechas, 
    //         values: { desde: moment(desde), hasta: moment(hasta)}
    //     })
    // }

    return informes.filter((informe) =>
        filtersToApply.every(({ filter, values }) =>
            filter(informe, values)));
};

export const getDetalladoTotalesYPagosActual = (informes, pagosFechas) => {

    const fechas = pagosFechas ? { 
        desde: moment(pagosFechas.desde), 
        hasta: moment(pagosFechas.hasta)
    } : null;

    const extraInfo = informes.reduce((info, documento) => {

        const { id_docCobro, descuento, condonacion, recargo, cargo, saldo } = documento;
        const { colTotales, pagosActual } = info;

        const pagoActual = getPagoActual(documento, fechas);

        pagosActual.push(pagoActual);

        colTotales.Descuentos += descuento;
        colTotales.Condonados += condonacion;
        colTotales.Recargos += recargo;
        colTotales.Importes += cargo;
        colTotales.Pagados += pagoActual;
        colTotales.Saldos += id_docCobro !== null ? saldo : -pagoActual;

        return info;

    }, {
        colTotales: { Importes: 0, Descuentos: 0, Condonados: 0, Recargos: 0, Pagados: 0, Saldos: 0 },
        pagosActual: []
    });

    return extraInfo;
};

export const getConcentradoTotalesYPagosActual = (informes, headersInfo, pagosFechas = null) => {

    const fechas = pagosFechas ? { 
        desde: moment(pagosFechas.desde), 
        hasta: moment(pagosFechas.hasta)
    } : null;

    const setConcentradoTotalesFormat = (cargo = 0, descuento = 0, condonacion = 0, recargo = 0, pago = 0, total = 0) => {
        return { cargo, descuento, condonacion, recargo, pago, total }
    };
    
    const sumConcentradoTotales = (acum, producto, pagoActual) => {
    
        return setConcentradoTotalesFormat(
            acum.cargo + producto.cargo,
            acum.descuento + producto.descuento,
            acum.condonacion + producto.condonacion,
            acum.recargo + producto.recargo,
            acum.pago + (pagoActual ?? producto.pago),
            acum.total + producto.total
        );
    };

    const totales = informes.reduce((totales, concentrado, index) => {

        const { colTotales, rowTotales, pagosActual } = totales;
        const { productos, id_vivienda } = concentrado;

        headersInfo.forEach(({ id }) => {
            const producto = productos.find(({ id_producto }) => id_producto === id);
            const pagoActual = getPagoActual(producto, fechas);
            rowTotales[id_vivienda] = sumConcentradoTotales(rowTotales[id_vivienda], producto, pagoActual);
            colTotales[id] = sumConcentradoTotales(colTotales[id], producto, pagoActual);
            pagosActual[index][id] = pagoActual;
        });

        colTotales['TotalesCol'] = sumConcentradoTotales(colTotales['TotalesCol'], rowTotales[id_vivienda]);

        return totales;

    }, {
        colTotales: /* by producto  */
            headersInfo.reduce((totales, { id }) => ({ ...totales, [id]: setConcentradoTotalesFormat() }),
                { 'TotalesCol': setConcentradoTotalesFormat() }),
        colPerc: /* by producto */
            headersInfo.reduce((totales, { id }) => ({ ...totales, [id]: 0 }),
                { 'TotalesCol': 0 }),
        rowTotales: /* by vivienda */
            informes.reduce((totales, { id_vivienda }) => ({ ...totales, [id_vivienda]: setConcentradoTotalesFormat() }), {}),
        pagosActual: /* by index */
            informes.map((doc) => doc.productos.reduce((prods, { id_producto }) => ({ ...prods, [id_producto]: 0 }), {})),
    });

    if (informes.length > 0) {

        headersInfo.concat({ header: 'TotalesCol', id: 'TotalesCol' }).forEach(({ header, id }) => {
            const { pago, total } = totales.colTotales[id];

            /* Hacer suma de totales de columnas aqui en vez ? */
            totales.colPerc[id] = total ? (pago / total) * 100 : 0;
        });
    }

    return totales;
};

export const getDetalladoPagosActual = (informes, pagosFechas) => {

    const fechas = pagosFechas && pagosFechas.desde && pagosFechas.hasta ?  { 
        desde: moment(pagosFechas.desde), 
        hasta: moment(pagosFechas.hasta)
    } : null; 

    return informes.map((informe) => {

        const { id_docCobro, saldo } = informe;

        const pagoActual = getPagoActual(informe, fechas);
        
        return { ...informe, pago: pagoActual, saldo: id_docCobro !== null ? saldo : -pagoActual  }
    });
};

export const getConcentradosPagosActual = (informes, pagosFechas) => {

    const fechas = pagosFechas && pagosFechas.desde && pagosFechas.hasta ?  { 
        desde: moment(pagosFechas.desde), 
        hasta: moment(pagosFechas.hasta)
    } : null;

    return informes.map((informe, index) => {

        const productos = informe.productos.map((producto) => {

            const pagoActual = getPagoActual(producto, fechas);
            
            return { ...producto, pago: pagoActual }
        });

        return { ...informe, productos };
    })
};

export const getPagosFiltered = (informes, pagosFechas) => {

    const reduceFilteredPagosFormat = (documento, fechas) => {
    
        const { pagos, vivienda, num_folio, producto } = documento;
    
        return pagos.reduce((filteredInfos, current) => {
    
            const pagoIsBetweenFilter = fechas ? isPagoInDateRange(current.fecha, fechas) : true;
    
            if (pagoIsBetweenFilter && current.pago > 0)
                filteredInfos.push({
                    vivienda, num_folio, producto,
                    comentarios: current.comentarios, forma_pago: current.forma_pago,
                    Fecha_Pago: current.fecha, Total_Pagado: current.pago
                });
    
            return filteredInfos;
    
        }, []);
    };
    
    const getSafFormat = (documento, fechas) => {
    
        const { saf, vivienda, num_folio, producto } = documento;
    
        const lastSaf = saf[saf.length - 1];
    
        const getSafInfoAfterDateRange = (saf, fechas) => {
    
            const safAfterDateRangeIndex = getSafAfterDateRangeIndex(saf, fechas);
    
            if(safAfterDateRangeIndex === -1) return { pago: lastSaf.saldo, fecha: lastSaf.fecha }
            if(safAfterDateRangeIndex === 0) return { pago: 0, fecha: '' };
    
            const foundSaf = saf[safAfterDateRangeIndex - 1];
            
            return { pago: foundSaf.saldo, fecha: foundSaf.fecha };
    
        };
        
        const safInRange = fechas ? getSafInfoAfterDateRange(saf, fechas) : { pago: lastSaf.saldo, fecha: lastSaf.fecha };
    
        const safFormat = { vivienda, num_folio, producto,
            Fecha_Pago: safInRange.fecha, Total_Pagado: safInRange.pago
        };
    
        return safFormat.Total_Pagado > 0 ? [safFormat] : []
    };

    const fechas = pagosFechas && pagosFechas.desde && pagosFechas.hasta ? { 
        desde: moment(pagosFechas.desde), 
        hasta: moment(pagosFechas.hasta)
    } : null;

    return informes.flatMap((documento) => {

        const { pagos, saf } = documento

        return pagos.length > 0 ? reduceFilteredPagosFormat(documento, fechas)
            : saf.length > 0 ? getSafFormat(documento, fechas)
            : [];
    });
};
